import TrafficSources from '../../pages/dashboard/TrafficSources'
import { Card, Flex, Placeholder } from '@aws-amplify/ui-react'
import React from 'react'
import './Productivity.css';
interface ProductivityProps {
    data: {
        title?: string;
        totalHours?: string;
        days?: string;
        percentage?: string;
    };
    trafficSourceData: any;
    label: any;
    colors: any;
    classname?: string;
    customScale?: any;
}
const Productivity: React.FC<ProductivityProps> = ({ customScale, data, trafficSourceData, label, colors, classname }) => {
    const hours = trafficSourceData?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const calculatedDays = hours / 24;
    const totalDays = Math.round(calculatedDays * 10) / 10;

    return (
        <Card height="auto" borderRadius="15px" className="productivity-card">
            <div className="card-title">{data.title}</div>
            {
                data.totalHours && data.percentage && data.days ?
                    <div className="productivity-container">
                        <div className="time">
                            <span className="hour">
                                <h2>{hours + "h"}</h2>
                                <span>Hours saved</span>
                            </span>
                            <span className="days">{totalDays + " days"}</span>
                        </div>
                        <span>
                            {`+${data.percentage}% this week`}
                        </span>
                    </div> :
                    null
            }
            <div className="chart-wrap">
                {trafficSourceData ? (
                    <div className='traffic-chart-section'>
                    <TrafficSources
                        title="Traffic Sources"
                        data={trafficSourceData}
                        type="donut"
                        labels={label}
                        colors={colors}
                        classname={classname}
                        customScale={customScale}
                    />
                    </div>
                ) : (
                    <Flex direction="column" minHeight="285px">
                        <Placeholder size="small" />
                        <Placeholder size="small" />
                        <Placeholder size="small" />
                        <Placeholder size="small" />
                    </Flex>
                )}
            </div>
        </Card>
    )
}

export default Productivity;